import React from 'react';
import { Route, BrowserRouter as Router, Routes, Link  } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import config from '../Config';

export const Banner = () => {

    const navigate = useNavigate();
  return (
    <>
    <section className='banner-bg min-heght'>
      <img className="banr-nwdots" src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bannerbg.svg`} alt='Dots' />
      
        <Container>
           <Row>
            <div className='text-left col-md-5'>
            <span><img src='assets/imgs/tcbportalicon.svg' alt='TCB Pay Portal' /> TCB PAY PORTAL</span>
            <h1>Your one-stop-shop payment solution</h1>
            <p>Our custom-built payment processing solution offers unmatched simplicity and efficiency.</p> 
            <p>Accessible from any device at any time, enjoy the flexibility to accept payments in multiple currencies, and with multiple MIDs consolidated into one single account.</p>
            {/* <Link to={`${config.siteBaseUrl}#show-calendly`} className="get-btn1">Get Started</Link> */}
            <Link to="https://portal.tcbpay.com/app/signup" target="_blank" className="get-btn1">Get Started</Link>
            <Link to={`${config.siteBaseUrl}/contact`} className="contact-btn">Contact Us</Link>
            </div>
            <div className='col-md-7'>
            <img src='assets/imgs/portal-banner.svg' alt='TCB Pay Portal payment' className='banner2'/>
            </div>
          </Row>    
        </Container>

    </section>
    
    </>
  )
}
